import(/* webpackMode: "eager" */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\landing-pages\\en\\customer-experience-platform-middle-east\\page.js");
